/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Balance from './Balance';

/**
 * The SettlementControllerDtoListSettlementDailySettlement model module.
 * @module model/SettlementControllerDtoListSettlementDailySettlement
 * @version 1.0
 */
class SettlementControllerDtoListSettlementDailySettlement {
    /**
     * Constructs a new <code>SettlementControllerDtoListSettlementDailySettlement</code>.
     * @alias module:model/SettlementControllerDtoListSettlementDailySettlement
     */
    constructor() { 
        
        SettlementControllerDtoListSettlementDailySettlement.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SettlementControllerDtoListSettlementDailySettlement</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SettlementControllerDtoListSettlementDailySettlement} obj Optional instance to populate.
     * @return {module:model/SettlementControllerDtoListSettlementDailySettlement} The populated <code>SettlementControllerDtoListSettlementDailySettlement</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SettlementControllerDtoListSettlementDailySettlement();

            if (data.hasOwnProperty('settlementId')) {
                obj['settlementId'] = ApiClient.convertToType(data['settlementId'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'Date');
            }
            if (data.hasOwnProperty('settlements')) {
                obj['settlements'] = ApiClient.convertToType(data['settlements'], {'String': Balance});
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SettlementControllerDtoListSettlementDailySettlement</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SettlementControllerDtoListSettlementDailySettlement</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['settlementId'] && !(typeof data['settlementId'] === 'string' || data['settlementId'] instanceof String)) {
            throw new Error("Expected the field `settlementId` to be a primitive type in the JSON string but got " + data['settlementId']);
        }

        return true;
    }


}



/**
 * @member {String} settlementId
 */
SettlementControllerDtoListSettlementDailySettlement.prototype['settlementId'] = undefined;

/**
 * @member {Date} date
 */
SettlementControllerDtoListSettlementDailySettlement.prototype['date'] = undefined;

/**
 * @member {Object.<String, module:model/Balance>} settlements
 */
SettlementControllerDtoListSettlementDailySettlement.prototype['settlements'] = undefined;






export default SettlementControllerDtoListSettlementDailySettlement;

